module.exports = __webpack_public_path__ + "img/bg.762fe3b3.svg";